import { ColumnModal, Input } from "@/components";
import { useCallback, useState } from "react";
import { useRenamePlaylist } from "@/app/modules/Playlists/hooks/useRenamePlaylist.tsx";
import { useTranslate } from "@/providers/context";

interface UpdatePlaylistModalProps {
  playlistId?: number;
  existingName: string;
  open: boolean;
  setOpen: (open: boolean) => void;
  onSuccess?: () => void;
}

export const UpdatePlaylistModal = ({
  open,
  setOpen,
  existingName,
  playlistId,
  onSuccess,
}: UpdatePlaylistModalProps) => {
  const { translate } = useTranslate();
  const [name, setName] = useState(existingName);
  const renamePlaylist = useRenamePlaylist();

  const handleConfirm = useCallback(() => {
    if (!name || !playlistId) {
      return;
    }
    renamePlaylist.mutate({ PlaylistName: name, PlaylistId: playlistId });
    setOpen(false);
    if (onSuccess) {
      onSuccess();
    }
  }, [name, renamePlaylist, playlistId, setOpen, onSuccess]);

  const handleCancel = useCallback(() => {
    setName(existingName);
    setOpen(false);
  }, [existingName, setOpen]);

  return (
    <ColumnModal
      hideTrigger
      title={translate("Rename Playlist")}
      primaryText={translate("Confirm")}
      cols={3}
      open={open}
      onOpenChange={setOpen}
      onCancel={handleCancel}
      onConfirm={handleConfirm}
    >
      <div className="my-6 px-6">
        <Input
          size="s"
          type="text"
          placeholder={translate("Example Playlist")}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>
    </ColumnModal>
  );
};
